import { getParsedErrorMessage } from 'redux/axios';
import { ChecklistMetricStatus } from '../../handoff-checklist-v2/handoff-checklist-v2.types';
import {
  MessagingAirMetricDefinition,
  MetricEvalContext,
} from '../messaging-air-metrics.types';
import { getMessagingAiTasksReviewedCountQueryOptions } from '../messaging-air-handoff.queries';
import { WEAVE_APP_URL } from 'apis/sso/sso-url-config';

export const MIN_REVIEWED_AI_TASKS = 3;

// Warning-only: never returns BLOCKED, since this does not block handoff in V1.
export const evaluateMessagingAiTasksReviewed = async (ctx: MetricEvalContext) => {
  try {
    const response = await ctx.queryClient.fetchQuery(
      getMessagingAiTasksReviewedCountQueryOptions(ctx.locationId)
    );
    const count = response?.reviewed ?? 0;

    if (count >= MIN_REVIEWED_AI_TASKS) {
      return {
        status: ChecklistMetricStatus.PASSED,
        reason: 'messaging_ai_tasks_reviewed' as const,
        message: `${count} messaging AI tasks were reviewed in the last 7 days.`,
      };
    }
    return {
      status: ChecklistMetricStatus.WARNING,
      reason: 'messaging_ai_tasks_pending' as const,
      message: `${count} messaging AI tasks were reviewed in the last 7 days. Recent AI tasks may need review before handoff.`,
    };
  } catch (err) {
    return {
      status: ChecklistMetricStatus.WARNING,
      reason: 'api_request_failed' as const,
      message:
        getParsedErrorMessage(err) || 'Failed to verify reviewed messaging AI tasks.',
    };
  }
};

export const messagingAiTasksReviewedMetric: MessagingAirMetricDefinition = {
  id: 'messaging_ai_tasks_reviewed',
  name: 'Messaging AI Tasks Reviewed',
  isRequired: false,
  criteria: [
    {
      description: 'At least 3 messaging AI tasks have been reviewed in the last 7 days.',
      evaluate: evaluateMessagingAiTasksReviewed,
      whereToFix: {
        label: 'Task center in Weave',
        url: WEAVE_APP_URL,
      },
    },
  ],
};
